import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showExpandedCategoryPopupAction } from './actions';

export const useExpandedPopup = (
    cid,
    gameCodes,
    displayName,
    isRecommendedCategory,
    formatCategoryName,
    mostPlayedGame
) => {
    const dispatch = useDispatch();

    return useCallback(
        popupData => dispatch(showExpandedCategoryPopupAction(
            popupData,
            cid,
            gameCodes,
            displayName,
            isRecommendedCategory,
            formatCategoryName,
            mostPlayedGame
        )),
        [
            dispatch,
            cid,
            gameCodes,
            displayName,
            isRecommendedCategory,
            formatCategoryName,
            mostPlayedGame
        ]
    );
};
